<template>
  <div class="home">
  <ImpresoraNavar/>
  <ImpresoraBanner/>
  <ImpresoraCategorias/>
  <ImpresoraFaq/>
   <FooterSection/>
  </div>
</template>

<script>
import ImpresoraNavar from '@/components/Impresora/ImpresoraNavar.vue';
import ImpresoraBanner from '@/components/Impresora/ImpresoraBanner.vue';
import ImpresoraCategorias from '@/components/Impresora/ImpresoraCategorias.vue';
import ImpresoraFaq from '@/components/Impresora/ImpresoraFaq.vue';
import FooterSection from '@/components/FooterSection.vue';


export default {
  name: 'HomeView',
  components: {
    ImpresoraNavar,
    ImpresoraBanner,
    ImpresoraCategorias,
    ImpresoraFaq,
    FooterSection,
  }
}
</script>
